import { render, staticRenderFns } from "./AlertsBar.vue?vue&type=template&id=2b3221b1"
import script from "./AlertsBar.vue?vue&type=script&lang=js"
export * from "./AlertsBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports